module.exports = __webpack_public_path__ + "../resources/img/ic_minus_light.d5a1ef5a.svg";